<template>
  <BFormRadioGroup
    :model-value="locale"
    :options="options"
    buttons
    size="sm"
    button-variant="outline-light"
    :aria-label="$t('modules.common.language')"
    @update:model-value="onSelect"
  />
</template>

<script setup lang="ts">
import { runDetached } from '@hprofits/utils';
import { computed } from 'vue';

import { useLocaleSwitcher } from '@/composables/useLocaleSwitcher';
import { isAppLocale } from '@/i18n/messages';

const { locale, choices, switchLocale } = useLocaleSwitcher();

const options = computed(() => choices.map(({ value, label }) => ({ value, text: label })));

// The catalogue for the picked locale may still have to be fetched, so switching is async. A chunk
// that never arrives leaves the radio on the previous locale — logged rather than swallowed, so the
// failure is not invisible.
const onSelect = (next: unknown): void => {
  if (isAppLocale(next)) {
    runDetached(switchLocale(next));
  }
};
</script>
